import { constants } from "../../misc/constants";
import Scenario1 from "./Scenario1";
import { SbarUIConfig } from "../../components/ui/SbarUI";
import { FullPageQuizQuestion } from "../../components/ui/FullPageQuizUI";
import { TransformUIConfig } from "../../components/ui/TransformUI";
import MedsurgBaseScenarioPart from "../MedsurgBaseScenarioPart";
import { Window508Type } from "../MedsurgBaseScenario";

export default class Scenario1Part5 extends MedsurgBaseScenarioPart {

	chapterIds = {
		chapterCinematic1: 'medsurg-cinematic-1-1',        
		chapterCinematic23: 'medsurg-cinematic-1-23',
		chapterCinematic27: 'medsurg-cinematic-1-27',
        chapterCinematic28: 'medsurg-cinematic-1-28', //CAN BE REPLACED
        chapterCinematic35: 'medsurg-cinematic-1-35',
		chapterCinematic57: 'medsurg-cinematic-1-57', // added sweaty gown loop used in 1-2
		chapterCinematic60: 'medsurg-cinematic-1-60',
		chapterCinematic61: 'medsurg-cinematic-1-61',
		chapterCinematic62: 'medsurg-cinematic-1-62',
		chapterCinematic67: 'medsurg-cinematic-1-67',
		chapterCinematic72: 'medsurg-cinematic-1-72',
		chapterCinematic76: 'medsurg-cinematic-1-76', // for testing - currently set to female 01
		chapterCinematic77: 'medsurg-cinematic-1-77', // for testing - currently set to female 02
		chapterCinematic74: 'medsurg-cinematic-1-74', // for testing - currently set to male 01
		chapterCinematic75: 'medsurg-cinematic-1-75', // for testing - currently set to male 02
		chapterCinematic78: 'medsurg-cinematic-1-78',
        chapterCinematic79: 'medsurg-cinematic-1-79',
		chapterCinematic80: 'medsurg-cinematic-1-80',

	}

	constructor(scenario: Scenario1, private onDone: () => void){
		super(scenario);
	}

	private PrInstanceID: string;
	private TalkInstanceID1: string;
	private ActionInstanceID1: string;
	private RememberDisplayed: boolean = false;
	private ActionInstanceID2: string;
	private ActionInstanceID3: string;
	private MoveInstanceID: string;
	private FpInstanceID: string;
	private rrtSelected: boolean;
	private provSelected: boolean;

	private Talk1: boolean = false;
	private Talk2: boolean = false;
	private Talk3: boolean = false;
	private Talk4: boolean = false;
	private Action1: boolean = false;
	private Action3: boolean = false;
	private Action4: boolean = false;
	private Action5: boolean = false;
	private Action6: boolean = false;
	private Action7: boolean = false;
	private Action11: boolean = false;
	private Action12: boolean = false;
	private Action13: boolean = false;
	private Action14: boolean = false;
	private Action15: boolean = false;
	private Action31: boolean = false;
	private Action32: boolean = false;
	private Action33: boolean = false;
	private Action34: boolean = false;

	private TalkCount: number = 0;
	private OldTalkCount: number = 0;
	private ActionCount: number = 0;
	private OldActionCount: number = 0;
	private PAbool: boolean = false;
	private PObool: boolean = false;
	private gownChanged: boolean = false;
	
	private avatar1: boolean = false;
	private avatar2: boolean = false;
	private avatar3: boolean = false;
	private avatar4: boolean = false;

	
	public get partId(): string {
		return constants.scenarios.scenario1.parts.level1Part5.id;
	}

	public get videoUrl(): string[] {
		//return ['./assets/videos/scenario1/video1' + this.scenario.avatarIndx + '.mp4'];
		return ['./assets/videos/scenario1/video10.mp4'];
	}

	public start() {
		const context = this;
		if(this.scenario.avatarIndx === 0) {
			this.avatar1 = true;
			this.avatar2 = false;
			this.avatar3 = false;
			this.avatar4 = false;
		}
		else if(this.scenario.avatarIndx === 1) {
			this.avatar2 = true;
			this.avatar1 = false;
			this.avatar3 = false;
			this.avatar4 = false;
		}
		else if(this.scenario.avatarIndx === 2) {
			this.avatar3 = true;
			this.avatar2 = false;
			this.avatar1 = false;
			this.avatar4 = false;
		}
		else if(this.scenario.avatarIndx === 3) {
			this.avatar4 = true;
			this.avatar2 = false;
			this.avatar3 = false;
			this.avatar1 = false;
		}
		this.RememberDisplayed = false;
		context.segment1Step1IntroWalking();
	}

	private segment1Step1IntroWalking() {
		var context = this;
		this.scenario.destroyAllUIInstances();
		context.scenario.displayHeader();
		this.scenario.playAmbientLoop(this.scenario.audioHall);
		this.playVideoChapter(this.chapterIds.chapterCinematic1, () => {
			context.segment1Step2ContinueRoom1();
		});
    }

	private segment1Step4Remember() {
		var context = this;
		this.scenario.update508Window(Window508Type.Remember);
		this.scenario.displayRemember(() => {
			this.scenario.update508Window(Window508Type.Main);
			this.RememberDisplayed = true;
			context.scenario.destroyAllUIInstances();
			//context.skipPart();
		});
	}
	//use when skipping part for testing
	private skipPart() {
		var context = this;
		context.scenario.hideFooter();
        this.scenario.displayModalPop(
			null,
            'Skipping to part 6',
            () => {
                context.scenario.destroyAllUIInstances();
                    context.segment1StepFinal();
            }
        );
	}

    private segment1Step2ContinueRoom1() {
		this.scenario.destroyAllUIInstances();
        var context = this;
        context.scenario.gameManager.environment.blurFadeIn();
        this.scenario.displayModalPop(
			null,
            "Mrs. McLoughlin has returned to room 3 and her labs are in.",
            () => {
                this.scenario.stopAmbientLoop();
				this.scenario.playAmbientLoop(this.scenario.audioRoom);
				context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				this.playVideoChapter(this.chapterIds.chapterCinematic72, () => {}, true);
                context.PreloadUis();
				if(this.RememberDisplayed === false) {
					context.segment1Step4Remember();
				}
				this.scenario.displayFooter(() => this.PrInstanceID, () => this.TalkInstanceID1, () => this.ActionInstanceID1, '4', '9', false, false);
				context.TalkCount = 4;
				context.ActionCount = 9;
				context.getFooterCounts();
            }
        );
    }

	private segment1Part5Debrief() {
		var context = this;
		context.scenario.displayDebrief(9200, () => {
			localStorage.setItem('ignoreResumePopup', 'true');
			window.location.reload();
		}, () => {
			context.segment1StepFinal();
		});
	}

	private segment1StepFinal() {
        var context = this;
        context.scenario.destroyAllUIInstances();
    	context.partEnd();
    }

	private partEnd() {
        var context = this;
		this.scenario.stopAmbientLoop();
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;
		context.scenario.saveScore();
		context.onDone();
	}

    public PreloadUis(shouldHidePatientRecord?: boolean) {
        var context = this;
        this.PrInstanceID = (this.scenario as Scenario1).PrMcID;
		context.scenario.gameManager.UiManager.updateUIInstance(this.PrInstanceID, {
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.Remember);
				}, 500);
				this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
				// if(this.RememberDisplayed === false) {
				// 	context.segment1Step4Remember();
				// }
			}
		})

		if(shouldHidePatientRecord) {
			this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
		} else {
			setTimeout(() => {
				context.scenario.update508Window(Window508Type.PatientRecord);
			}, 500);
		}

		(this.scenario as Scenario1).PrMcID = this.PrInstanceID;

		context.TalkInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Talk',
			talks: [
				{
					toppx: '50px',
					titletext: 'How are you feeling?',
					onClicked: () => {
						this.segment1TalkFeeling();
					},
					disable: () => this.Talk1
				},
				{
					toppx: '150px',
					titletext: 'Your hands are trembling. Is that usual for you?',
					onClicked: () => {
						this.segment1TalkHands();
					},
					disable: () => this.Talk2
				},
				{
					toppx: '250px',
					titletext: 'On a scale of 0-10, can you rate your pain?',
					onClicked: () => {
						this.segment1TalkRate();
					},
					disable: () => this.Talk3
				},
				{
					toppx: '350px',
					titletext: 'Would you like something for the pain?',
					onClicked: () => {
						this.segment1TalkForPain();
					},
					disable: () => this.Talk4
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);

		this.ActionInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Action',
			talks: [
				{
					toppx: '50px',
					titletext: 'Take Vitals',
					onClicked: () => {
						this.segment1ActionVitals();
					},
					disable: () => this.Action1
				},
				{
					toppx: '150px',
					titletext: 'Assess Patient',
					onClicked: () => {
						this.segment1ActionAssess();
					},
					disable: () => this.Action3
				},
				{
					toppx: '250px',
					titletext: 'Change Gown',
					onClicked: () => {
						this.segment1ActionGown();
					},
					disable: () => this.Action4
				},
				{
					toppx: '350px',
					titletext: 'Re-inforce Dressing',
					onClicked: () => {
						this.segment1ActionDress();
					},
					disable: () => this.Action5
				},
				{
					toppx: '450px',
					titletext: 'Replace Tape',
					onClicked: () => {
						this.segment1ActionTape();
					},
					disable: () => this.Action6
				},
				{
					toppx: '550px',
					titletext: 'Assess Patient Condition',
					onClicked: () => {
						this.segment1ActionCondition();
					},
					disable: () => this.Action7
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
	}

	private segment1ActionVitals() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID2 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Take Vitals',
			talks: [
				{
					toppx: '50px',
					titletext: 'Temperature',
					onClicked: () => {
						context.segment1ActionTemperature();
					},
					disable: () => this.Action11
				},
				{
					toppx: '150px',
					titletext: 'Blood Pressure',
					onClicked: () => {
						context.segment1ActionBloodPressure();
					},
					disable: () => this.Action12
				},
				{
					toppx: '250px',
					titletext: 'Pulse',
					onClicked: () => {
						context.segment1ActionPulse();
					},
					disable: () => this.Action13
				},
				{
					toppx: '350px',
					titletext: 'Respirations',
					onClicked: () => {
						context.segment1ActionRespirations();
					},
					disable: () => this.Action14
				},
				{
					toppx: '450px',
					titletext: 'O2 Sat Level',
					onClicked: () => {
						context.segment1ActionSatLevel();
					},
					disable: () => this.Action15
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1ActionAssess() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID3 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Assess Patient',
			talks: [
				{
					toppx: '50px',
					titletext: 'Abdomen',
					onClicked: () => {
						context.segment1ActionAbdomen();
					},
					disable: () => this.Action31
				},
				{
					toppx: '150px',
					titletext: 'Surgical Site',
					onClicked: () => {
						context.segment1ActionSite();
					},
					disable: () => this.Action32
				},
				{
					toppx: '250px',
					titletext: 'IV Insertion Site',
					onClicked: () => {
						context.segment1ActionIV();
					},
					disable: () => this.Action33
				},
				{
					toppx: '350px',
					titletext: 'Assess Blood Glucose',
					onClicked: () => {
						context.segment1ActionBlood();
					},
					disable: () => this.Action34
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1TalkFeeling() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			scenario: this,
			toppx: '70px',
			loadQuiz: true,
			titletext: 'How are you feeling?',
			isTalks: true,
			extBottom: true,
			extText: "Worse than before. My head is still pounding, and now I'm really nauseas too. I itch all over, and I can't get comfortable. I'm sweating like crazy - is it hot in here? Could I get a fresh gown?",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PObool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
						title: context.scenario.patientObservation,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PObool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientObservation)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk1 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 900,
					talktext1: 'Patient Observation',
					talktext2: 'General',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Headache',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Nausea',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Trembling',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Sweating',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Itching',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic78, () => {
			if(this.gownChanged) {
				this.playVideoChapter(this.chapterIds.chapterCinematic27, () => {}, true); //NEED GOWN ANIM, CHANGE CINEMATIC LEFT TO GOWN LOOP
			} else this.playVideoChapter(this.chapterIds.chapterCinematic72, () => {}, true);
		});
	}

	private segment1TalkHands() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			scenario: this,
			toppx: '170px',
			loadQuiz: true,
			titletext: 'Your hands are trembling. Is that usual for you?',
			isTalks: true,
			extBottom: true,
			extText: "No. I was just in a really bad accident. I'm in the hospital. I just had a major operation. So I'm shaky, ok?",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PObool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
						title: context.scenario.patientObservation,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PObool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientObservation)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk2 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 1100,
					talktext1: 'Pain Observation',
					talktext2: 'General',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Headache',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Nausea',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Trembling',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Sweating',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Itching',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic79, () => {
			if(this.gownChanged) {
				this.playVideoChapter(this.chapterIds.chapterCinematic27, () => {}, true); //NEED GOWN ANIM, CHANGE CINEMATIC LEFT TO GOWN LOOP
			} else this.playVideoChapter(this.chapterIds.chapterCinematic72, () => {}, true);
		});
	}

	private segment1TalkRate() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '270px',
			scenario: this,
			loadQuiz: true,
			titletext: 'On a scale of 0-10, can you rate your pain?',
			isTalks: true,
			isPainScale: true,
			painScaleMaxPoints: 100,
			painScaleCorrect: 7,
			extBottom: true,
			extText: "Still a seven, I guess.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.evaluateScoreForPainScale(updatedConfig);
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PAbool = true;
				}
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
					header: 'Pain Scale',
					list: '<li>'+updatedConfig.painAssessment+'</li>',
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
				this.Talk3 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic80, () => {
			if(this.gownChanged) {
				this.playVideoChapter(this.chapterIds.chapterCinematic27, () => {}, true); //NEED GOWN ANIM, CHANGE CINEMATIC LEFT TO GOWN LOOP
			} else this.playVideoChapter(this.chapterIds.chapterCinematic72, () => {}, true);
		});
	}

	private segment1TalkForPain() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			scenario: this,
			toppx: '370px',
			loadQuiz: true,
			titletext: 'Would you like something for the nausea?',
			isTalks: true,
			extBottom: true,
			extText: "No, thanks.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
					title: context.scenario.medicineAdministered,
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.medicineAdministered)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk4 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 100,
					binaryq: true,
					talktext1: 'Medication Administered',
					talktext2: ' ',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Yes',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic23, () => {
			if(this.gownChanged) {
				this.playVideoChapter(this.chapterIds.chapterCinematic27, () => {}, true); //NEED GOWN ANIM, CHANGE CINEMATIC LEFT TO GOWN LOOP
			} else this.playVideoChapter(this.chapterIds.chapterCinematic72, () => {}, true);
		});
	}

	private segment1ActionTemperature() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Temperature',
			vitaltext: '99.8',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_temp.png',
			onSubmit: () => {
				this.Action11 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcVitalsID, {
					list: '<li>Temperature : 99.8</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionBloodPressure() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '170px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Blood Pressure',
			vitaltext: '172/98',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_bp.png',
			onSubmit: () => {
				this.Action12 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcVitalsID, {
					list: '<li>Blood Pressure : 172/98</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionPulse() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Pulse',
			vitaltext: '138',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_pulse.png',
			onSubmit: () => {
				this.Action13 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcVitalsID, {
					list: '<li>Pulse : 138</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionRespirations() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '370px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Respirations',
			vitaltext: '24',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_respiration.png',
			onSubmit: () => {
				this.Action14 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcVitalsID, {
					list: '<li>Respirations : 24</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionSatLevel() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '470px',
			scenario: this,
			loadQuiz: true,
			titletext: 'O2 Sat Level',
			vitaltext: '98%',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_o2.png',
			onSubmit: () => {
				this.Action15 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcVitalsID, {
					list: '<li>02 Sat Level : 98%</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionAbdomen() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '70px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Abdomen',
			isTalks: true,
			extTop: true,
			extImg: 'AssessingAbdominal',
			extText: 'Abdomen feels soft and mildly distended, bowel sounds hypoactive',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action31 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 6,
					quiztop: '5px',
					maxPoints: 750,
					talktext1: 'Patient Assessment',
					talktext2: 'Abdomen',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Normal',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Distention: Mild',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Distention: Moderate',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Distention: Severe',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Bowel Sounds: Present',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Bowel Sounds: Absent',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionSite() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '170px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Surgical Site',
			isTalks: true,
			extTop: true,
			extImg: 't3',
			extText: 'Dressing tape is not intact.',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action32 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 6,
					quiztop: '5px',
					maxPoints: 750,
					talktext1: 'Patient Assessment',
					talktext2: 'Surgical Site',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Clean',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Free of infection',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Bleeding',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Drainage',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Infection',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Non-intact dressing',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionIV() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '270px',
			scenario: this,
			loadQuiz: true,
			titletext: 'IV Insertion Site',
			isTalks: true,
			extTop: true,
			extImg: 't0', //NEED IMAGE
			extText: 'Tape is non-intact',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action33 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 7,
					quiztop: '5px',
					maxPoints: 1250,
					talktext1: 'Patient Assessment',
					talktext2: 'IV Insertion Site',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Intact',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No redness',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'No leakage',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Redness',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Leakage',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Infection',
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: 'Tape non-intact',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionBlood() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '370px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Assess Blood Glucose',
			isTalks: true,
			extTop: true,
			extImg: 'Finger_stick_104',
			extText: '104 mg/dL',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action34 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 50,
					binaryq: true,
					talktext1: 'Patient Assessment',
					talktext2: 'Finger Stick',
					talks: [
						{
							buttontop: '150px',
							buttontext: '76 mg/dL',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: '104 mg/dL',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: '180 mg/dL',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: '400 mg/dL',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionGown() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Change Gown',
			isTalks: true,
			onSubmit: () => {
				context.scenario.updateScore(100);
				this.Action4 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.gameManager.environment.blurFadeIn();
				setTimeout(() => {
					this.gownChanged = true;
					this.playVideoChapter(this.chapterIds.chapterCinematic27, () => {}, true); //NEED GOWN ANIM, CHANGE CINEMATIC LEFT TO GOWN LOOP
				}, 1000)
				setTimeout(() => {
					context.scenario.gameManager.environment.blurFadeOut();
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1500);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts();
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionDress() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '370px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Re-Inforce Dressing',
			isTalks: true,
			extTop: true,
			extImg: 't2',
			extText: "You've replaced the patient's surgical dressing",
			onSubmit: () => {
				this.Action5 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.updateScore(250);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts();
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionTape() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '470px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Replaced Tape',
			isTalks: true,
			extTop: true,
			extImg: 't1', //NEED IMAGE
			extText: 'Replaced Tape',
			onSubmit: () => {
				this.Action6 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.updateScore(250);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts();
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionCondition() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '570px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Assess Patient Condition',
			isTalks: true,
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -500px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			context.showFullPageQuiz();
		}, 2200);
	}

	private showFullPageQuiz() {
		var context = this;
		context.scenario.hideFooter();
		context.scenario.gameManager.environment.blurFadeIn();
		context.scenario.update508Window(Window508Type.FullPageQuiz)
		this.FpInstanceID = this.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.FullPageQuizUI, {
			questions: [
				{
					title: 'What do you want to assess for?',
					options: [
						{
							title: 'ETOH Withdrawal',
							isCorrect: true,
							points: 0
						},
						{
							title: 'Head Injury',
							isCorrect: false,
							points: 0
						},
						{
							title: 'Postoperative Bleeding',
							isCorrect: false,
							points: 0
						}
					],
					incorrectFeedback: 'Although head injury/postoperative bleeding is a realistic suspicion, that is not what is happening in this scenario. Please try again.'
				},
				{
					title: "Does your patient have nausea or vomiting?",
					options: [
						{
							title: 'Yes',
							isCorrect: true,
							points: 0
						},
						{
							title: 'No',
							isCorrect: false,
							points: 0
						}
					],
					incorrectFeedback: 'Your patient has stated that she is nauseous. Please try again.'
				},
				{
					title: 'Does your patient exhibit tactile disturbances such as itching, pins-and-needles sensations, burning, numbness, or feels like bugs are crawling on or under the skin?',
					options: [
						{
							title: 'Yes',
							isCorrect: true,
							points: 0
						},
						{
							title: 'No',
							isCorrect: false,
							points: 0
						}
					],
					incorrectFeedback: 'Your patient has stated that she is very itchy. Please try again.',
				},
				{
					title: 'Is your patient exhibiting tremors?',
					options: [
						{
							title: 'Yes',
							isCorrect: true,
							points: 0
						},
						{
							title: 'No',
							isCorrect: false,
							points: 0
						}
					],
					incorrectFeedback: 'Your patient has exhibited significant tremors. Please try again.',
				},
				{
					title: 'Is your patient exhibiting auditory disturbances such as hearing things they know are not there?',
					options: [
						{
							title: 'Yes',
							isCorrect: false,
							points: 0
						},
						{
							title: 'No',
							isCorrect: true,
							points: 0
						}
					],
					incorrectFeedback: 'Your patient has not experienced any auditory disturbances. Please try again.',
				},
				{
					title: 'Is your patient experiencing paroxysmal sweats?',
					options: [
						{
							title: 'Yes',
							isCorrect: true,
							points: 0
						},
						{
							title: 'No',
							isCorrect: false,
							points: 0
						}
					],
					incorrectFeedback: 'Your patient has experienced paroxysmal sweating. Please try again.',
				},
				{
					title: 'Is your patient experiencing visual disturbances? Does the light appear to be too bright or is she seeing things she knows are not there?',
					options: [
						{
							title: 'Yes',
							isCorrect: true,
							points: 0
						},
						{
							title: 'No',
							isCorrect: false,
							points: 0
						}
					],
					incorrectFeedback: 'Your patient has stated that the light is hurting her eyes. Please try again.',
				},
				{
					title: 'Is your patient anxious or guarded?',
					options: [
						{
							title: 'Yes',
							isCorrect: true,
							points: 0
						},
						{
							title: 'No',
							isCorrect: false,
							points: 0
						}
					],
					incorrectFeedback: 'Your patient has exhibited anxious and guarded behavior. Please try again.',
				},
				{
					title: 'Does your patient have a headache?',
					options: [
						{
							title: 'Yes',
							isCorrect: true,
							points: 0
						},
						{
							title: 'No',
							isCorrect: false,
							points: 0
						}
					],
					incorrectFeedback: 'Your patient has complained of a headache. Please try again.',
				},
				{
					title: 'Is your patient fidgety or restless?',
					options: [
						{
							title: 'Yes',
							isCorrect: true,
							points: 0
						},
						{
							title: 'No',
							isCorrect: false,
							points: 0
						}
					],
					incorrectFeedback: 'Your patient has been noticeably fidgety and restless. Please try again.',
				},
				{
					title: 'Is your patient disoriented or confused about place and date?',
					options: [
						{
							title: 'Yes',
							isCorrect: true,
							points: 0
						},
						{
							title: 'No',
							isCorrect: false,
							points: 0
						}
					],
					incorrectFeedback: 'Your patient has exhibited confusion. Please try again.',
				},
				{
					title: 'Based on your answers, there is a strong possibility that your patient is experiencing ETOH withdrawal. What would you like to do next?',
					options: [
						{
							title: 'Contact Provider',
							isProv: true,
							isRrt: false,
							isFail: false,
							points: 0
						},
						{
							title: 'Call RRT',
							isRrt: true,
							isProv: false,
							isFail: false,
							points: 0
						},
						{
							title: 'Exit Room',
							isFail: true,
							isRrt: false,
							isProv: false,
							points: 0
						}
					],
					incorrectFeedback: 'Incorrect',
				}
			],
			onSingleQuestionSubmitted: (question: FullPageQuizQuestion) => {
				var correctOptions = question.options.filter(o => o.isCorrect);
				
				var correctPoints = 0;
				correctOptions.forEach(co => correctPoints += co.points);

				var selectedOptions = question.options.filter(o => o.isSelected);
				var correctSelectedOptions = question.options.filter(o => o.isCorrect && o.isSelected);
				var isCorrect = correctOptions.length === correctSelectedOptions.length && selectedOptions.length === correctOptions.length;
				var rrtOption = question.options.filter(o => o.isRrt);
				var rrtSelectedOption = question.options.filter(o => o.isRrt && o.isSelected);
				var provOption = question.options.filter(o => o.isProv);
				var provSelectedOption = question.options.filter(o => o.isProv && o.isSelected);
				var failOption = question.options.filter(o => o.isFail);
				var failSelectedOption = question.options.filter(o => o.isFail && o.isSelected);
				var isRRT = rrtOption.length === rrtSelectedOption.length && selectedOptions.length === rrtOption.length;
				var isProv = provOption.length === provSelectedOption.length && selectedOptions.length === provOption.length;
				var isFailed = failOption.length === failSelectedOption.length && selectedOptions.length === failOption.length;
				if(isProv) {
					this.provSelected = true;
					context.scenario.updateScore(1000);
				}
				else if(isRRT) {
					this.rrtSelected = true;
					context.scenario.updateScore(1000);
				}
				else if(isFailed) {
					this.scenario.gameManager.UiManager.hideUiInstance(this.FpInstanceID);
					context.segment2ActionFail();
				}
				else if(isCorrect) {
					context.scenario.updateScore(250);
				}
				else {
					this.scenario.gameManager.UiManager.hideUiInstance(this.FpInstanceID);
					this.scenario.showFeedback(question.incorrectFeedback, () => {
						this.scenario.gameManager.UiManager.showUiInstance(this.FpInstanceID);
						this.scenario.update508Window(Window508Type.FullPageQuiz)
					})
				}

				return isCorrect || isProv || isRRT;
			},
			onDone: () => {
				context.scenario.update508Window(Window508Type.TalkActionsUI)

				this.Action7 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.gameManager.UiManager.destroyUIInstanceById(this.FpInstanceID);
				context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
				context.checkIfDone();
			}
		});	
	}

	private segment2ActionFail() {
		var context = this;
		this.scenario.gameManager.environment.blurFadeIn();
		this.scenario.displayModalPop(
			null,
            "Your patient has had an adverse event. Please report to the nurses’ station to speak with your charge nurse.",
            () => {
                context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
				context.scenario.updateFooter('0', '0', true, true);
				context.scenario.hideFooter();
				context.segment2ActionChargeNurse();
            }
        );
	}

	private segment2ActionChargeNurse() {
		var context = this;
		//NEED FAIL ANIM, CHANGE CHAPTERCINEMATICS BELOW TO EACH PLAYER CHARACTER LOOP
		if(this.avatar1) {
			this.playVideoChapter(this.chapterIds.chapterCinematic76, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		} else if (this.avatar2) {
			this.playVideoChapter(this.chapterIds.chapterCinematic77, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		} else if (this.avatar3) {
			this.playVideoChapter(this.chapterIds.chapterCinematic74, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		} else if (this.avatar4) {
			this.playVideoChapter(this.chapterIds.chapterCinematic75, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		}
		setTimeout(() => {
			context.segment2ActionChargeNurseNext();
		}, 1000);
	}

	private segment2ActionChargeNurseNext() {
		var context = this;
		//context.scenario.gameManager.environment.blurFadeIn();
		context.scenario.showRemediation(
			'I would like to discuss Ms. McLoughlin’s change in condition. When a patient is unstable, the nurse should remain at the bedside and call for help. The Rapid Response Team (RRT) is available to respond to patients who are having a change in condition. A critically ill patient can deteriorate quickly and have a respiratory or cardiac arrest. Intervening earlier by notifying the Provider or RRT would have prevented Ms. McLoughlin from having an adverse event. Please return to Room #3 and begin caring for your patient again.',
			'./assets/images/general/icons/npc-headshots/ChargeNurse.png',
			() => {
				context.scenario.gameManager.environment.blurFadeOut();
				localStorage.setItem('ignoreResumePopup', 'true');
				window.location.reload();
			}
		)
	}

	private checkIfDone() {
		var context = this;
		if(this.Action7 === true) {
			context.scenario.hideFooter();
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			if(this.provSelected === true) {
				context.segment1ActionProvider();
			}
			else if(this.rrtSelected === true) {
				context.segment1ActionRRT();
			}
		}
		else context.getFooterCounts();
	}

	private getFooterCounts() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
		}
		else if(this.TalkCount === 0 && this.ActionCount !== 0) {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else if(this.TalkCount !== 0 && this.ActionCount === 0) {
			context.scenario.updateFooter(this.TalkCount.toString(), '0', false, true);
			context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), false, false)
		};
	}

	private checkIfSubMenu() {
		var context = this;
		if(this.Action11 === true && this.Action12 === true && this.Action13 === true && this.Action14 === true && this.Action15 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);	
			this.Action1 = true;
			this.ActionCount = this.OldActionCount - 1;
		};
		context.getFooterCounts();
	}

	private checkIfSubMenu2() {
		var context = this;
		if(this.Action31 === true && this.Action32 === true && this.Action33 === true && this.Action34 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.Action3 = true;
		};
		context.getFooterCounts();
	}

	private segment1ActionProvider() {
		var context = this;
		context.scenario.destroyAllUIInstances();
		context.scenario.gameManager.environment.blurFadeOut();
		if(this.gownChanged) {
			this.playVideoChapter(this.chapterIds.chapterCinematic62, () => {}); //check anims
		} else {this.playVideoChapter(this.chapterIds.chapterCinematic61, () => {});}
		context.scenario.showProvider(
			"Hi Nurse, what's the situation?",
			() => {
				context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
				context.scenario.gameManager.environment.blurFadeIn();
				context.segment2showSbar();
			}
		);
	}

	private segment1ActionRRT() {
		var context = this;
		context.scenario.destroyAllUIInstances();
		context.scenario.gameManager.environment.blurFadeOut();
		context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
		if(this.gownChanged) {
			this.playVideoChapter(this.chapterIds.chapterCinematic35, () => { //check anims
				context.scenario.gameManager.environment.blurFadeIn();
				context.segment2showSbar();
			});
		} else {
			this.playVideoChapter(this.chapterIds.chapterCinematic60, () => {
				context.scenario.gameManager.environment.blurFadeIn();
				context.segment2showSbar();
			});
		}
	}

	private segment2showSbar() {
		var context = this;
		context.scenario.update508Window(Window508Type.SbarUI)
		this.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.SbarUI, {
			s: {
				maxPoints: 250,
				options: [
					{
						text: 'ETOH Withdrawal',
						isCorrect: true
					},
					{
						text: 'Blood Loss',
						isCorrect: false
					},
					{
						text: 'Side effect of medication',
						isCorrect: false
					},
					{
						text: 'Concussion',
						isCorrect: false
					},
					{
						text: 'Hypoglycemia',
						isCorrect: false
					}
				]
			},
			basic: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).mcBasicID),
			nurses: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).mcNursesID),
			r: {
				maxPoints: 200,
				options: [
					{
						text: 'Transfer care to ICU',
						isCorrect: true
					},
					{
						text: 'Medication',
						isCorrect: false
					},
					{
						text: 'Labs',
						isCorrect: false
					},
					{
						text: 'Implement ETOH withdrawal protocol',
						isCorrect: true
					}
				]
			},
			correctFeedback: 'Good job, you have correctly relayed critical information. Please review the SBAR and continue.',
			incorrectFeedback: 'You have incorrectly relayed critical information. Accurate patient information ensures patient safety and quality care provided by medical staff and Providers. Please continue to review the corrected SBAR.',
			onSubmitted: (result: SbarUIConfig) => {
				this.scenario.evaluateScoreForSbar(result);
			},
			onClose: (result: SbarUIConfig) => {
				context.scenario.destroyAllUIInstances();
				if(this.provSelected === true) {
					context.scenario.gameManager.environment.blurFadeOut();
					context.scenario.showProvider(
						"I agree that, based upon your assessment, ETOH withdrawal is a good possibility. I'm going to have Ms. McLoughlin transferred to ICU. Great work!",
						() => {
							context.segment1Part5Debrief();
						}
					);
				}
				else {
					context.scenario.gameManager.environment.blurFadeOut();
					context.scenario.showProvider(
						"We're going to transfer Ms. McLoughlin to the ICU to monitor her more closely. Thank you. Exit Room.",
						() => {
							context.segment1StepFinal();
						}
					);
				}
			},
			onSetWindow: (window: Window508Type) => {
				context.scenario.update508Window(window);
			}
		});
	}
}